import type { ResultStat } from '../types'

export const resultStats: ResultStat[] = [
  { id: 'negocios', value: '100+', label: 'negocios con web activa' },
  { id: 'entrega', value: '7', label: 'días promedio de entrega' },
  { id: 'rating', value: '4.9★', label: 'calificación promedio' },
  { id: 'respuesta', value: '24h', label: 'para recibir tu cotización' },
]
